// Applies the stored theme before the app mounts, so it doesn't flash light first
export default defineNuxtPlugin(() => {
  applyTheme(useTheme().choice.value)
})
